import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface CheckoutButtonProps {
  subscriptionType: 'monthly' | 'yearly';
  planId: string;
  priceId: string;
  credits: number;
  userEmail: string;
  interval: string;
  currentCredits: number;
  className?: string;
}

export const CheckoutButton = ({ subscriptionType, planId, priceId, credits, userEmail, interval, currentCredits, className = '' }: CheckoutButtonProps) => {
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleCheckout = async () => {
    if (!user) {
      console.error('User not logged in');
      navigate('/login');
      return;
    }

    setLoading(true);
    try {
      console.log('Creating checkout session for:', {
        subscriptionType,
        planId,
        userId: user.id
      });

      const response = await fetch('/api/create-checkout-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user.access_token}`
        },
        body: JSON.stringify({
          priceId,
          userId: user.id,
          userEmail,
          credits,
          interval,
          currentCredits,
          successUrl: `${window.location.origin}/success`,
          cancelUrl: `${window.location.origin}/cancel`
        }),
        credentials: 'include'
      });

      if (!response.ok) {
        let errorMessage = 'Failed to create checkout session';
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorMessage;
        } catch (e) {
          console.error('Error parsing error response:', e);
        }
        throw new Error(`${errorMessage} (Status: ${response.status})`);
      }

      const data = await response.json();
      console.log('API response:', data);
      if (data.url) {
        window.location.href = data.url;
      } else if (data.error) {
        throw new Error(data.error);
      } else {
        throw new Error('No checkout URL received');
      }
    } catch (error) {
      console.error('Checkout error:', error);
      if (error instanceof Error && error.message.includes('not logged in')) {
        navigate('/login');
      } else {
        alert(`Failed to start checkout: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleCheckout}
      disabled={loading || !user}
      className={`px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-400 ${className}`}
    >
      {loading ? 'Načítání...' : `Koupit ${subscriptionType === 'monthly' ? 'měsíční' : 'roční'}`}
    </button>
  );
}; 